import { useaxios } from "../../../utils/useaxios";
export default (from, to) => initDispatch => clear => settype => {
    useaxios('report/summary/summary.php', { from, to }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            initDispatch({ type: 'setsummary_report', payload: { summary_report_total_sell: res.total_sell, summary_report_total_profit: res.total_profit, summary_report_total_expense: res.total_expense, summary_report_total_gift: res.total_gift, summary_report_total_broke: res.total_broke, summary_report_total_stock_price: res.total_stock_price, summary_report_total_loan_in: res.total_loan_in, summary_report_total_loan_out: res.total_loan_out, summary_report_total_save: res.save, profitdetail_array: res.profitdetail_array } });
            settype('summary_report');
            // setrecaller(recaller + 1);
        }
    });
}